import * as React from 'react';

function NotFound() {
  return (
    <div style={{marginLeft: "30px"}}>
      <h1>404 Not Found</h1>
    </div>
  );
}

export default NotFound;